// ContactUs.js
import React from "react";

const ContactUs = () => {
  return (
    <section className="contact-root" aria-label="Contact VyBly">
      <style>{`
        :root{
          --bg-dark:#0e2430;
          --bg-deep:#0b1a22;
          --teal-300:#49b1ba;
          --gold-500:#f5b400;
          --gold-600:#e7a400;
          --text:#f4fbfc;
          --muted:#cfe1e4;
          --card:#0f2a36cc;
          --ring:#2bb3bf55;
        }

        *{box-sizing:border-box}

        .contact-root {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;

          color: var(--text);
          background-color: var(--bg-dark);
          background-image:
            radial-gradient(1200px 700px at 85% -10%, #174b54 0%, transparent 60%),
            radial-gradient(1000px 600px at 10% 20%, #123a44 0%, transparent 55%),
            linear-gradient(180deg, var(--bg-dark), var(--bg-deep));
          background-repeat: no-repeat;
          background-size: cover;

          font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
        }

        .scroll-area {
          width: 100%;
          height: 100%;
          overflow-y: auto;
          padding: clamp(28px, 5vw, 64px);
        }

        .hex{
          position:absolute;
          width:clamp(60px, 9vw, 120px);
          aspect-ratio:1/1;
          background:var(--gold-500);
          clip-path: polygon(25% 6.7%,75% 6.7%,100% 50%,75% 93.3%,25% 93.3%,0% 50%);
          filter: drop-shadow(0 12px 24px #0006);
          opacity:.85;
          animation: float 12s ease-in-out infinite;
          pointer-events:none;
        }
        .hex.teal{ background: var(--teal-300); }
        .hex.a{ top:8%; right:12%; animation-delay: -2s; }
        .hex.b{ top:22%; right:26%; transform:scale(.9); animation-delay:-6s;}
        .hex.c{ bottom:18%; left:10%; transform:scale(1.05); }
        .hex.d{ bottom:8%; right:6%; transform:scale(.75); animation-delay:-3s;}
        @keyframes float{
          0%,100%{ transform:translateY(0) rotate(0deg) }
          50%{ transform:translateY(-16px) rotate(6deg) }
        }
        @media (prefers-reduced-motion: reduce){ .hex{ animation:none } }

        .wrap{ width:min(1100px, 100%); position:relative; z-index:1; margin-inline:auto; }
        .hero{
          display:grid;
          grid-template-columns: 1.2fr .8fr;
          gap: clamp(24px, 4vw, 48px);
          align-items:stretch;
        }
        @media (max-width: 960px){
          .hero{ grid-template-columns: 1fr; }
          .side{ margin-top: 32px; }
        }

        @media (min-width: 961px) {
          .wrap { margin-top: 60px; }
        }
        @media (max-width: 960px) {
          .wrap { margin-top: 40px; }
        }

        .title{
          font-weight:900;
          line-height:1.02;
          letter-spacing:-0.02em;
          font-size: clamp(40px, 7vw, 76px);
          margin:0 0 12px;
          text-shadow: 0 2px 0 #0004, 0 10px 28px #0009;
        }
        .subtitle{
          color:var(--muted);
          font-size: clamp(16px, 2.2vw, 18px);
          line-height:1.65;
          margin:0 0 28px;
        }

        .card{
          background: var(--card);
          border:1px solid var(--ring);
          border-radius: 22px;
          padding: clamp(20px, 3vw, 28px);
          backdrop-filter: blur(10px);
          box-shadow: 0 14px 34px #0009, inset 0 1px 0 #ffffff12;
        }
        .stack{ display:flex; flex-direction:column; gap:14px; }

        .row{
          display:flex; align-items:center; gap:14px;
          padding:14px 16px; border-radius:14px;
          background: #0c2029cc; border:1px solid #ffffff18;
        }
        .icon{ width:28px; height:28px; display:grid; place-items:center; }

        .row.email .icon svg {
          stroke: var(--gold-500);
          fill: var(--gold-500);
        }
        .row.instagram .icon svg {
          stroke: var(--teal-300);
          fill: var(--teal-300);
        }
        .row.tiktok .icon svg {
          stroke: #fff;
          fill: #fff;
        }

        .label{ color:#e7f3f5; font-weight:700; margin-bottom:4px; }
        .email a, .instagram a, .tiktok a {
          color:#ffffff; text-decoration:none; font-weight:800; letter-spacing:.2px;
        }
        .email a:hover, .instagram a:hover, .tiktok a:hover { text-decoration:underline; }

        .cta{ margin-top:8px; display:flex; gap:12px; flex-wrap:wrap; }
        .btn{
          appearance:none; border:none; cursor:pointer;
          padding:14px 18px; border-radius:16px;
          font-weight:800; letter-spacing:.3px;
          background:linear-gradient(180deg,var(--gold-500),var(--gold-600));
          color:#0a1216;
          box-shadow: 0 12px 26px #0008, 0 0 0 4px #00000010;
          transition: transform .12s ease, filter .12s ease;
        }
        .btn:hover{ transform: translateY(-2px); filter:brightness(1.03); }

        .small{ font-size:13px; color:var(--muted); margin-top:8px; }

        .side h3{ margin:0 0 10px; font-size: clamp(18px, 2.2vw, 22px); color:#f0fbfc; }
        .side p{ color:#d1e5e8; margin:.25rem 0 1rem; line-height:1.6; }
        .hr{ border:none; border-top:1px solid #ffffff1a; margin:14px 0; }

        .wave{
          position:absolute; left:0; right:0; bottom:-1px; height:160px; width:100%;
          z-index:0;
        }
      `}</style>

      <span className="hex a" />
      <span className="hex teal b" />
      <span className="hex c" />
      <span className="hex teal d" />

      <div className="scroll-area">
        <div className="wrap">
          <section className="hero">
            <div>
              <h1 className="title">Let’s Talk.</h1>
              <p className="subtitle">
                Questions, partnerships, press—drop a line and I’ll read it.
              </p>

              <div className="card stack">
                {/* Email */}
                <div className="row email">
                  <span className="icon" aria-hidden>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M3.5 6.5h17v11h-17v-11Z" stroke="currentColor" strokeWidth="1.6" opacity=".95"/>
                      <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.6"/>
                    </svg>
                  </span>
                  <div>
                    <div className="label">General & Partnerships</div>
                    <div><a href="mailto:info@vybly.net">info@vybly.net</a></div>
                  </div>
                </div>

                {/* Instagram */}
                <div className="row instagram">
                  <span className="icon" aria-hidden>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="3.5" y="3.5" width="17" height="17" rx="4" stroke="currentColor" strokeWidth="1.6"/>
                      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.6"/>
                      <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/>
                    </svg>
                  </span>
                  <div>
                    <div className="label">Instagram</div>
                    <a href="https://instagram.com/vybly.hq" target="_blank" rel="noreferrer">@vybly.hq</a>
                  </div>
                </div>

                {/* TikTok */}
                <div className="row tiktok">
                  <span className="icon" aria-hidden>
                    {/* TikTok SVG */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="24" height="24" fill="currentColor">
                      <path d="M41 15.3c-2.6-.2-5.2-1.2-7.2-2.8v16.6c0 8.1-6.6 14.7-14.7 14.7S4.4 37.2 4.4 29.1c0-7.6 5.8-13.9 13.3-14.6v7.5c-3.2.7-5.6 3.5-5.6 6.9 0 3.9 3.2 7 7 7s7-3.2 7-7V4h7c0 2.5 1 4.8 2.6 6.5 1.5 1.5 3.6 2.5 5.9 2.8V15.3z"/>
                    </svg>
                  </span>
                  <div>
                    <div className="label">TikTok</div>
                    <a href="https://www.tiktok.com/@vybly.hq" target="_blank" rel="noreferrer">@vybly.hq</a>
                  </div>
                </div>

                <div className="cta">
                  <a className="btn" href="mailto:info@vybly.net">Email Us</a>
                </div>

                <div className="small">
                  It’s a one-person inbox. I read every note and reply as soon as I can—thanks for your patience and kindness.
                </div>
              </div>
            </div>

            <aside className="card side" role="complementary" aria-label="Why email">
              <h3>A quick note</h3>
              <p>Email keeps things searchable and lets me loop in the right person when needed.</p>
              <div className="hr" />
              <h3>Heads-up on replies</h3>
              <p>I’m building this with care. If I’m slow, it’s because I’m hands-on. Your message matters.</p>
            </aside>
          </section>
        </div>
      </div>

      <svg className="wave" viewBox="0 0 1440 160" preserveAspectRatio="none" aria-hidden>
        <path fill="#f5b400" d="M0,120 C220,180 360,40 560,76 C800,116 980,200 1440,70 L1440,160 L0,160 Z"/>
      </svg>
    </section>
  );
};

export default ContactUs;
